import React from 'react';
import { X, Settings } from 'lucide-react';

/**
 * Advanced settings modal
 */
export default function SettingsPanel({ settings, setSettings, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-[#6e32b9] to-[#32215d] rounded-2xl p-8 max-w-2xl w-full border border-white/20 shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/10 rounded-lg">
              <Settings className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-white">Advanced Settings</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            <X className="w-6 h-6 text-white" />
          </button>
        </div>

        {/* Settings Content */}
        <div className="space-y-6">
          {/* Tempo Sync Mode */}
          <div className="bg-white/10 rounded-xl p-6 border border-white/20">
            <h3 className="text-white font-medium mb-4">Tempo Sync Mode (Optional)</h3>
            <p className="text-white/70 text-sm mb-4">
              Tie phase lengths to beats using BPM for musical theatre timing
            </p>
            
            <div className="space-y-4">
              <div>
                <label className="text-white/80 text-sm block mb-2">BPM</label>
                <input
                  type="number"
                  min="40"
                  max="200"
                  value={settings?.bpm}
                  onChange={(e) => setSettings(prev => ({ ...prev, bpm: parseInt(e?.target?.value) || 60 }))}
                  className="w-full bg-white/5 border border-white/20 rounded-lg px-4 py-2 text-white"
                />
              </div>

              <div>
                <label className="text-white/80 text-sm block mb-2">Beats Per Phase</label>
                <input
                  type="number"
                  min="1"
                  max="16"
                  value={settings?.beatsPerPhase}
                  onChange={(e) => setSettings(prev => ({ ...prev, beatsPerPhase: parseInt(e?.target?.value) || 4 }))}
                  className="w-full bg-white/5 border border-white/20 rounded-lg px-4 py-2 text-white"
                />
              </div>

              <div className="text-white/60 text-sm">
                Phase duration: {(60 / settings?.bpm * settings?.beatsPerPhase)?.toFixed(1)}s
              </div>
            </div>
          </div>

          {/* Accessibility */}
          <div className="bg-white/10 rounded-xl p-6 border border-white/20">
            <h3 className="text-white font-medium mb-4">Accessibility</h3>
            
            <div className="space-y-3">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={settings?.lowMotion}
                  onChange={(e) => setSettings(prev => ({ ...prev, lowMotion: e?.target?.checked }))}
                  className="w-5 h-5 rounded"
                />
                <div>
                  <span className="text-white/80 block">Low Motion Mode</span>
                  <span className="text-white/60 text-xs">Reduces animation for sensitive users</span>
                </div>
              </label>
            </div>
          </div>
        </div>

        {/* Close Button */}
        <div className="mt-8 text-center">
          <button
            onClick={onClose}
            className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-xl font-bold transition-all"
          >
            Save & Close
          </button>
        </div>
      </div>
    </div>
  );
}